module.exports = __webpack_public_path__ + "img/0Q3B0162-L_FoamcoreMatted.5d176e41.jpg";